import React from "react"
export function FareAlert(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M11.996 17a2 2 0 11-3.998 0h3.998zm-2-15c.547 0 .99.448.99 1v1.1c2.26.463 3.959 2.481 3.959 4.9v4l1.466 2.223c.152.23.09.54-.137.693A.491.491 0 0116 16H3.994a.497.497 0 01-.495-.5c0-.099.03-.195.084-.277L5.049 13V9c0-2.419 1.7-4.436 3.958-4.9V3c0-.552.443-1 .99-1zm-4.504.31l.589 1.38a4.251 4.251 0 00-2.576 3.697l-.006.213H2a5.75 5.75 0 013.27-5.19l.222-.1zm9.016.005l.222.1a5.75 5.75 0 013.265 4.951l.005.24h-1.5l-.005-.215a4.25 4.25 0 00-2.385-3.609l-.19-.087.588-1.38z"
        fill="currentColor"
        id="prefix__fare-alert"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
